import _ from "lodash"

function DragDataManager (props) {
    const {targetData, sourceData, initialState = {}, randomizeOptions = false, randomizeTargets = false} = props

    this.reduce = (actions, state) => {
        return actions.reduce((prev, curr) => {
            return curr(prev)
        }, state)
    }

    this.skip = () => {
        return prev => prev
    }

    this.createState = () => {
        let newTargetState = targetData.map((zone,index) => {
            return {
                i: index,
                k:'dT_'+index, // key
                dS: [], // droppedSources hold {i, k} of dragItmes in target
                cN: '',
                aS: ''
            }
        })
        if (randomizeTargets) newTargetState = _.shuffle(newTargetState)
        let newUnplacedState = sourceData.map((item, index)=>{
            return {i:index, k:'dI_'+index, cN:'', aS: ''}
        })
        if (randomizeOptions) newUnplacedState = _.shuffle(newUnplacedState)
        return {unplacedSourcesState:newUnplacedState, targetStates:newTargetState}
    }

    this.dragData = {}
    this.dragData.mergeSourceStateWithData = (stateList) => {

        if(stateList.length === 0 || stateList[0] === undefined) return []
        return stateList.map((item)=>{
            return {...sourceData[item.i], ...item, aS: item.aS || item.cN}
        })
    }
    this.dragData.mergeTargetStateWithData = (stateList) => {
        if(stateList.length === 0 || stateList[0] === undefined) return []
        return stateList.map((item)=>{
            return {...targetData[item.i], ...item}
        })
    }

    this.dragData.getAllSourcesWithData = (selectorState)=>{
        const sourceList = selectorState.targetStates.flatMap((item)=>{
            return (_.cloneDeep(item.dS))
        })
        sourceList.splice(0,0,..._.cloneDeep(selectorState.unplacedSourcesState))
        return this.dragData.mergeSourceStateWithData(sourceList)
    }
    this.dragData.getSourceTarget = (sourceState, selectorState) => {
        const targetKey = sourceState.t
        const targetState = selectorState.targetStates.reduce((prev, curr)=>{
            if (prev) return prev
            if (curr.k === targetKey) return curr
            return prev
        },null)
        if (targetState === null) return ''
        return this.dragData.mergeTargetStateWithData([targetState])[0]
    }

    this.dragData.evaluateTargets = (selectorState) => {
        const targets = this.dragData.mergeTargetStateWithData(selectorState.targetStates)
        const targetResults = targets.map(target => {
            const correctIds = target.correctSourceIds.split(',')
            const targetSourceList = this.dragData.mergeSourceStateWithData(target.dS)
            const correctSources = []
            const incorrectSources = []
            targetSourceList.forEach((source)=>{
                if (correctIds.includes(source.id)){
                    correctSources.push(source)
                } else {
                    incorrectSources.push(source)
                }
            })
            return {passed:(correctSources.length === correctIds.length), target, correctSources, incorrectSources}
        })
        return ({passed:targetResults.every(target=>target.passed), targetResults})
    }

    this.dragData.evaluateSources = (selectorState) => {
        const sources = this.dragData.getAllSourcesWithData(selectorState)
        const correctSources = []
        const incorrectSources = []
        const passed = sources.reduce((pre, cur) => {
            const correctIds = cur.correctTargetIds.split(',')
            const match = correctIds.find(cId => cId === this.dragData.getSourceTarget(cur, selectorState).id) !== undefined
            if(match){
                correctSources.push(cur)
            } else {
                incorrectSources.push(cur)
            }
            return pre ? match : pre
        },true)
        return ({passed, correctSources, incorrectSources})
    }

    // for instant validation
    this.dragData.evaluateInstant = (selectorState, judgeType = 'target') => {
        let results = {
            passed: false,
            correctSources: [],
            incorrectSources: []
        }
        if(judgeType === 'target') {
            results['target'] = selectorState.target
            const correctIds = selectorState.target.correctSourceIds.split(',')
            const match = correctIds.find(cId => cId === selectorState.source.id) !== undefined
            if(match){
                results.correctSources.push(selectorState.target)
                results.passed = true
            } else {
                results.incorrectSources.push(selectorState.target)
            }
        } else if(judgeType === 'source') {
            const correctIds = selectorState.source.correctTargetIds.split(',')
            const match = correctIds.find(cId => cId === selectorState.target.id) !== undefined
            if(match){
                results.correctSources.push(selectorState.source)
                results.passed = true
            } else {
                results.incorrectSources.push(selectorState.source)
            }
        }
        return results
    }

    this.removeItem = (item) => {

        const updateFunction = (previousInputs) => {
            const itemIndex = previousInputs.unplacedSourcesState.findIndex(i=>i.k===item.k)
            const newUnplacedSourcesState = [...previousInputs.unplacedSourcesState]
            if (itemIndex > -1 ){
                newUnplacedSourcesState.splice(itemIndex,1)

            }

            const newTargetStates = _.cloneDeep(previousInputs.targetStates)
            const targetIndex = previousInputs.targetStates.reduce((prev, cur, iDZ)=>{
                if (prev) return prev
                const index = cur.dS.findIndex(i=>i.k===item.k)
                if (index >- 1) return [iDZ,index]
                return null
            },null)
            if(targetIndex !== null){
                newTargetStates[targetIndex[0]].dS.splice(targetIndex[1],1)
            }

            return ({unplacedSourcesState:newUnplacedSourcesState, targetStates:newTargetStates})
        }

        return updateFunction
    }

    // Check the type of element to update the cN property
    this.getElementType = (element) => {
        const type = element.k.split('_')[0]
        switch(type){
            case 'dI':
                return 'source'
            default:
            case 'dT':
                return 'target'
        }
    }

    this.manager = {}
    this.manager.move = (itemData, target) => {
        /*
            May need to add new functionality:
                Find the current location of the item (not placed, or in a target)
                If new placement (target) is the same as old placement * Question: can you be in multiple targets (parents) *
                    This is an order move.
                If new placement is different, move item out of old target and into new. (do we need to worry about internal order in the target?)
                *Question: Should we have all the drag objects start in a target, so that they can be dragged back into it, removing it from the other targets?
        */
        const itemId = {i:itemData.i, k:itemData.k, cN:itemData.cN||''}

        const updateFunction = (previousInputs) => {
            const newInputs = this.removeItem(itemData)(previousInputs)
            const newUnplacedSourcesState = [...newInputs.unplacedSourcesState]
            if(target === undefined){
                newUnplacedSourcesState.push(itemId)
            }
            const newTargetStates = _.cloneDeep(newInputs.targetStates)
            if(target !== undefined){
                newTargetStates.find(i=>i.k===target.k).dS.push({...itemId, t:target.k})
            }

            return ({unplacedSourcesState:newUnplacedSourcesState, targetStates:newTargetStates})
        }
        return updateFunction
    }

    // AdditionalState contains the element classNames without the module hash, this helps to be more descriptive and keep the state cleaner.
    this.manager.addAdditionalState = (element, className) =>{

        const updateFunction = (previousInputs) => {
            const updatedState = _.cloneDeep(previousInputs)
            if(this.getElementType(element) === 'source'){
                if(previousInputs.unplacedSourcesState.find(i=>i.k===element.k) !== undefined) {
                    updatedState.unplacedSourcesState.find(i=>i.k===element.k).aS = className
                } else {
                    updatedState.targetStates.forEach(target => {
                        const sourceIndex = target.dS.findIndex(i=>i.k===element.k)
                        const found = sourceIndex !== -1
                        if(found){
                            target.dS[sourceIndex].aS = className
                        }
                    })
                }
            } else if(this.getElementType(element) === 'target'){
                updatedState.targetStates.find(i=>i.k===element.k).aS = className
            }
            return (updatedState)
        }
        return(updateFunction)

    }
    this.manager.removeAdditionalState = (element, className) =>{

        const updatedClassName = (oldState = '') => {
            let newState = oldState
            const classList = className.split(' ')
            classList.forEach(cN => {
                if(newState.includes(cN)){
                    newState = newState.replace(cN,'')
                }
            })
            return newState
        }

        const updateFunction = (previousInputs) => {
            const updatedState = _.cloneDeep(previousInputs)
            if(this.getElementType(element) === 'source'){
                if(previousInputs.unplacedSourcesState.find(i=>i.k===element.k) !== undefined) {
                    const targetId = updatedState.unplacedSourcesState.findIndex(i=>i.k===element.k)
                    updatedState.unplacedSourcesState[targetId].aS = updatedClassName(updatedState.unplacedSourcesState[targetId].aS)
                } else {
                    updatedState.targetStates.forEach(target => {
                        const sourceIndex = target.dS.findIndex(i=>i.k===element.k)
                        const found = sourceIndex !== -1
                        if(found){
                            target.dS[sourceIndex].aS = updatedClassName(target.dS[sourceIndex].aS)
                        }
                    })
                }
            } else if(this.getElementType(element) === 'target'){
                const targetId = updatedState.targetStates.findIndex(i=>i.k===element.k)
                updatedState.targetStates[targetId].aS = updatedClassName(updatedState.targetStates[targetId].aS)
            }
            return (updatedState)
        }
        return(updateFunction)
    }
    this.manager.order = (item, hover) => {
        // find what target the two items are in. 
        // reoder the the target array 
        // update arrays
        if (item.t !== hover.t) return

        const updateFunction = (previousInputs) => {
            const newUnplacedSourcesState = _.cloneDeep(previousInputs.unplacedSourcesState)
            const newTargetStates = _.cloneDeep(previousInputs.targetStates)
            if (!item.t){


                const itemIndex = newUnplacedSourcesState.findIndex(i=>i.k===item.k)
                const hoverIndex = newUnplacedSourcesState.findIndex(i=>i.k===hover.k)
                let replacementItem = newUnplacedSourcesState.splice(itemIndex,1)
                newUnplacedSourcesState.splice(hoverIndex,0,replacementItem[0])

            } else {


                const itemTargetIndex = newTargetStates.reduce((prev, cur, iDZ)=>{
                    if (prev) return prev
                    const index = cur.dS.findIndex(i=>i.k===item.k)
                    if (index > -1) return [iDZ,index]
                    return null
                },null)
                const hoverTargetIndex = newTargetStates.reduce((prev, cur, iDZ)=>{
                    if (prev) return prev
                    const index = cur.dS.findIndex(i=>i.k===hover.k)
                    if (index > -1) return [iDZ,index]
                    return null

                },null)
                let replacementItem = newTargetStates[itemTargetIndex[0]].dS.splice(itemTargetIndex[1],1)
                newTargetStates[itemTargetIndex[0]].dS.splice(hoverTargetIndex[1],0,replacementItem[0])


            }
            return ({unplacedSourcesState:newUnplacedSourcesState, targetStates:newTargetStates})
        }
        return (updateFunction)
    }
    // Helper functions

    this.manager.markItems = (results, config = {}) => {
        const updateFunction = (previousInputs) => {
            let newState = _.cloneDeep(previousInputs)
            const {correct = null, incorrect = null, sourceItems = {}} = config
            const {correct:sourceItems_correct = null, incorrect:sourceItems_incorrect = null} = sourceItems
            if (results.targetResults){// results from Targets
                results.targetResults.forEach(targetResult => {
                    targetResult.passed && correct && this.manager.addAdditionalState(targetResult.target, correct)
                    !targetResult.passed && incorrect && this.manager.addAdditionalState(targetResult.target, incorrect)
                    sourceItems_correct && targetResult.correctSources.forEach((source)=>{
                        newState = this.manager.addAdditionalState(source, correct)(newState)
                    })
                    sourceItems_incorrect && targetResult.incorrectSources.forEach((source)=>{
                        newState = this.manager.addAdditionalState(source, incorrect)(newState)
                    })
                })
            } else if (results.target) {// results from Target
                results.passed && correct && this.manager.addAdditionalState(results.target, correct)
                !results.passed && incorrect && this.manager.addAdditionalState(results.target, incorrect)
                sourceItems_correct && results.correctSources.forEach((source)=>{
                    newState = this.manager.addAdditionalState(source, correct)(newState)
                })
                sourceItems_incorrect && results.incorrectSources.forEach((source)=>{
                    newState = this.manager.addAdditionalState(source, incorrect)(newState)
                })
            } else if (results.correctSources) {// results from Sources
                correct && results.correctSources.forEach((source)=>{
                    newState = this.manager.addAdditionalState(source, correct)(newState)
                })
                incorrect && results.incorrectSources.forEach((source)=>{
                    newState = this.manager.addAdditionalState(source, incorrect)(newState)
                })
            }
            return (newState)
        }
        return(updateFunction)
    }
    this.manager.unmarkItems = (results, config = {}) => {
        const updateFunction = (previousInputs) => {
            let newState = _.cloneDeep(previousInputs)
            const {correct = null, incorrect = null, sourceItems = {}} = config
            const {correct:sourceItems_correct = null, incorrect:sourceItems_incorrect = null} = sourceItems
            if (results.targetResults){// results from Targets
                results.targetResults.forEach(targetResult => {
                    targetResult.passed && correct && this.manager.removeAdditionalState(targetResult.target, correct)
                    !targetResult.passed && incorrect && this.manager.removeAdditionalState(targetResult.target, incorrect)
                    sourceItems_correct && targetResult.correctSources.forEach((source)=>{
                        newState = this.manager.removeAdditionalState(source, correct)(newState)
                    })
                    sourceItems_incorrect && targetResult.incorrectSources.forEach((source)=>{
                        newState = this.manager.removeAdditionalState(source, incorrect)(newState)
                    })
                })
            } else if (results.target) {// results from Target
                results.passed && correct && this.manager.removeAdditionalState(results.target, correct)
                !results.passed && incorrect && this.manager.removeAdditionalState(results.target, incorrect)
                sourceItems_correct && results.correctSources.forEach((source)=>{
                    newState = this.manager.removeAdditionalState(source, correct)(newState)
                })
                sourceItems_incorrect && results.incorrectSources.forEach((source)=>{
                    newState = this.manager.removeAdditionalState(source, incorrect)(newState)
                })
            } else if (results.correctSources) {// results from Sources
                correct && results.correctSources.forEach((source)=>{
                    newState = this.manager.removeAdditionalState(source, correct)(newState)
                })
                incorrect && results.incorrectSources.forEach((source)=>{
                    newState = this.manager.removeAdditionalState(source, incorrect)(newState)
                })
            }
            return (newState)
        }
        return(updateFunction)
    }
    this.manager.returnItems = (results, config = {}) => {
        const updateFunction = (previousInputs) => {
            let newState = _.cloneDeep(previousInputs)
            const {correct = null, incorrect = null, sourceItems = {}} = config
            const {correct:sourceItems_correct = null, incorrect:sourceItems_incorrect = null} = sourceItems
            if (results.targetResults){// results from Targets
                results.targetResults.forEach(targetResult => {
                    sourceItems_correct && targetResult.correctSources.forEach((source)=>{
                        newState = this.manager.move(source, undefined)(newState)
                    })
                    sourceItems_incorrect && targetResult.incorrectSources.forEach((source)=>{
                        newState = this.manager.move(source, undefined)(newState)
                    })
                })
            } else if (results.target) {// results from Target
                correct && results.correctSources.forEach((source)=>{
                    newState = this.manager.move(source, undefined)(newState)
                })
                incorrect && results.incorrectSources.forEach((source)=>{
                    newState = this.manager.move(source, undefined)(newState)
                })
            } else if (results.correctSources) {// results from Sources
                correct && results.correctSources.forEach((source)=>{
                    newState = this.manager.move(source, undefined)(newState)
                })
                incorrect && results.incorrectSources.forEach((source)=>{
                    newState =  this.manager.move(source, undefined)(newState)
                })
            }
            return newState
        }
        return (updateFunction)
    }
}
export default DragDataManager